export interface GridColumnModel {
  id: string
  value: string
  selected: boolean
  orderBy: string
  isShown: boolean
  isFrozen: boolean
  width: string
  widthNum: number
  orderNo: number
}

export interface GridColumnViewInfoModelList extends GridColumnModel {
  displayType: string
}

export const viewInfoGridColumns: GridColumnViewInfoModelList[] = [
  {
    id: 'modelName',
    value: 'Model Name',
    selected: false,
    orderBy: 'modelName',
    isShown: true,
    isFrozen: true,
    width: '300px',
    widthNum: 350,
    displayType: 'text',
  },
  {
    id: 'productType',
    value: 'Product Type',
    selected: false,
    orderBy: 'productType',
    isShown: true,
    isFrozen: false,
    width: '200px',
    widthNum: 180,
    displayType: 'text',
  },
].map((column, index) => ({ ...column, orderNo: index + 1 }))
